import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav';
import ModeToggle from './ModeToggle';
import Sidebar from './Sidebar';

export default function Layout() {
  return (
    <div className="flex flex-col h-full bg-cream lg:pl-56">
      <Sidebar />
      {/* ModeToggle floats top-right on mobile; hidden on desktop (sidebar has its own toggle) */}
      <div className="lg:hidden">
        <ModeToggle />
      </div>
      <main className="flex-1 overflow-y-auto overflow-x-hidden pb-nav lg:pb-0">
        <div className="max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
      <BottomNav />
    </div>
  );
}
